
export class BaseAction {
    public static userVisible:boolean = true;
    public static getTitle:Function = () => 'DefaultAction';
    public static getDescription:Function = () => null;
    public static deviceLevel:boolean = false;
    public static categories:{ [key:string]:string } = null;
    public static types:{ [key:string]:string } = null;
    
    public static supportedRoutes:string[] = [ "push" ];
}